import { styled, CSSObject } from '../theming';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { fallbackTheme } from '../theming/fallbackTheme';
import { FooterProps } from './index';

export const FooterWrapper = styled.footer<FooterProps>`
  ${({ color, hasBorder, theme }): CSSObject => ({
    display: 'grid',
    justifyContent: 'center',
    backgroundColor:
      color === 'default' ? fallbackTheme(theme).color.neutral.surfaceLightened : color,
    borderTop: hasBorder
      ? `solid 1px ${color === 'default' ? fallbackTheme(theme).color.lines.lowContrast : color}`
      : 'none',
  })};

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    padding: 0 2.5rem;
    justify-content: stretch;
  }
`;

export const FooterContent = styled.div<{ hasOnlyOneSection: boolean }>`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-areas:
    'a a a a a a a a'
    'b b b b b b b b'
    'c c c c c c c c';
  grid-auto-rows: auto;
  margin: 0 ${tokens.size.x4};
  max-width: 75rem;
  text-align: center;
  padding: ${tokens.size.x8} 0px;

  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    grid-template-columns: repeat(12, auto);
    grid-template-rows: repeat(2, auto);
    grid-template-areas:
      'a a a a a a a a a a a a a'
      'b b b b b b b b c c c c c';
    margin: 0 auto;
    padding: 2.5rem 0;
    text-align: left;

    /* Center-align content if there is only one section. But add spacing between sections if there are more than one. */
    ${({ hasOnlyOneSection }) => !hasOnlyOneSection && 'width: 100%;'};
  }
`;

export const LinkFooterSection = styled.div`
  grid-area: a;
  margin-bottom: ${tokens.size.x4};
  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    margin-bottom: ${tokens.size.x6};
  }
`;

export const LinkFooterSectionSecondary = styled.div`
  grid-area: b;
  align-self: center;
  margin-bottom: ${tokens.size.x4};
  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    margin-bottom: 0;
  }
`;

export const IconFooterSection = styled.div`
  grid-area: c;
  @media (min-width: ${tokens.viewports.breakpoints.small}) {
    justify-self: end;
  }
`;
